import { notification } from 'antd';
import Router from 'next/router';
import request from '@/utils/axios';

export default payload => {
  return async () => {
    try {
      await request({
        url: 'askus/submitaskus',
        baseURL: process.env.V2_API_ROOT,
        method: 'POST',
        data: payload,
      }).then(response => {
        const { status, data } = response;
        if (status && status === 200) {
          notification.success({
            message: 'Success',
            description: data,
          });
          const confirmationURL = '/about/ask-us/submission-confirmation';
          Router.push(confirmationURL, confirmationURL);
        }
        if (status && status !== 200) {
          notification.error({
            message: 'Error',
            description: data,
          });
        }
      });
    } catch (err) {
      throw err;
    }
  };
};
